import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ShipmentTransportOrderPartiesService } from './shipment-transport-order-parties.service';
import {
  ShipmentTransportOrderPartiesListInitialState,
  ShipmentTransportOrderPartiesListLoad,
} from './shipment-transport-order-parties.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { CustomHttpErrorResponse, ListClientPaginationStateModel, NotificationService } from '../../../../../common';
import { TransportationTrackingParty } from '../../../../../ui-kit';

export type ShipmentTransportOrderPartiesListStateModel = ListClientPaginationStateModel<TransportationTrackingParty>;

const initialState: ShipmentTransportOrderPartiesListStateModel = {
  items: [],
  loaded: false,
};

@State<ShipmentTransportOrderPartiesListStateModel>({
  name: 'shipmentTransportOrderInvolvedParties',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderPartiesState {
  constructor(
    public transportOrderPartiesService: ShipmentTransportOrderPartiesService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: ShipmentTransportOrderPartiesListStateModel): ShipmentTransportOrderPartiesListStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentTransportOrderPartiesListStateModel): boolean {
    return state.loaded;
  }

  @Action(ShipmentTransportOrderPartiesListLoad)
  getShipmentTransportOrderPartiesList(
    ctx: StateContext<ShipmentTransportOrderPartiesListStateModel>,
    { payload }: ShipmentTransportOrderPartiesListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.transportOrderPartiesService.getParties(payload).pipe(
      take(1),
      map((partyList: TransportationTrackingParty[]) => {
        ctx.patchState({ items: partyList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderPartiesListInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderPartiesListStateModel>): void {
    ctx.setState(initialState);
  }
}
